import React from 'react';
import MyAccount from 'ViewModels/Components/MyAccount/MyAccount';
import OrderHistory from './OrderHistory/OrderHistoryContainer';
import PersonalInfo from './PersonalInfo/PersonalInfoContainer';
import BookAParty from './HostPortal/BookAParty';
import MyParties from './HostPortal/MyPartyListContainer';
import PartyDetails from './HostPortal/PartyDetails';
import { getUrlParameter } from '../../../Scripts/tools';
import auth from 'auth';
import LoginActions from './../Login/LoginActions';
import LoginStore from '../Login/LoginStore';


export default class MyAccountContainer extends React.Component {
	constructor(props) {
		super(props);
		let hash = window.location.hash ? window.location.hash.replace('#', '') : null;
		let isOrderPage = false;

        var eventCode = getUrlParameter('eventCode');
		if (eventCode != null) {

            if (!auth.loggedIn()) {
                window.location = window.jenkon.consultantRoot + "login?redirectUrl=" + window.location;
            }

			this.state = { component: <PartyDetails {...this.props} eventCode={eventCode} setView= { this.setView.bind(this) } />  };
		} else if(readCookie('isGuestCheckout') === "true") {
			this.state = { component: <OrderHistory resources={this.props.resources} setView={this.setView.bind(this)} />}		
		} else {
		    switch (hash) {
			    case 'bookaparty':
				    this.state = { component: <BookAParty {...this.props} setView={this.setView.bind(this)} /> };
				    break;
			    case 'partyDetails':
				    this.state = {
					    component: <PartyDetails {...this.props}/>
				    };
				    break;
			    default:
				    isOrderPage = this.checkIfOrderPage(hash);
				    this.state = {
					    component: isOrderPage ? <OrderHistory resources={this.props.resources} setView={this.setView.bind(this)} /> : 
					    <MyAccount initialTab={hash} resources={this.props.resources} setView={this.setView.bind(this)}/>
				    }
				    break;
			    }
        }
	}



    componentDidMount() {
        LoginStore.listen(this.onChange);
	}

    onChange(state) {
        this.setState(state);

    }

	checkIfOrderPage(hash) {
		let tabNames = ['myaddresses', 'personalinfo', 'mywishlist'];
		let hashIsATab = hash && (tabNames.indexOf(hash.toLowerCase()) !== -1);
		let isOrderID = (hash && !hashIsATab);
		return isOrderID;
	}

	setView(Component, eventCode) {
		eventCode = typeof eventCode === "string" ? eventCode : null;
		Component = typeof Component == 'function' ? Component : MyAccount;
		let propsDefault = {
			resources: this.props.resources,
			setView: this.setView.bind(this),
			eventCode,
		}
		this.setState({
			component: <Component {...propsDefault} />
		})
	}

	render(){
		return(
			<div className="site-container">
				{this.state.component}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/MyAccountContainer.js